import React from 'react';
import styled from '@emotion/styled';
import { shadowAround } from '../../styles';

const ExampleCard = styled.div`
  width: 100%;
  margin: 30px auto;
  color: ${(props) => props.theme.colors.font};
  padding: 8px 14px 14px 14px;
  border-left: 8px solid ${(props) => props.theme.colors.green};
  border-radius: 4px;
  line-height: 1.6;
  position: relative;
  background: ${(props) => props.theme.colors.blockquoteBackground};

  .exampleCardTitle {
    margin-bottom: 8px;
    color: ${(props) => props.theme.colors.green};
  }
`;

export default ({ children, ...props }) => {
  return <ExampleCard css={shadowAround}>
    <div class="exampleCardTitle">Example</div>
    <div {...props}>
      {children}
    </div>
  </ExampleCard>;
};
